import { render, staticRenderFns } from "./contractManagementAdd.vue?vue&type=template&id=b0477b5c&scoped=true"
import script from "./contractManagementAdd.vue?vue&type=script&lang=js"
export * from "./contractManagementAdd.vue?vue&type=script&lang=js"
import style0 from "./contractManagementAdd.vue?vue&type=style&index=0&id=b0477b5c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0477b5c",
  null
  
)

export default component.exports